import { ApplicationState } from 'application/redux';
import { connect } from 'react-redux';
import {
  fetchUserSettings,
  onChangeDropdowns,
  toggleUserSettings,
  updateUserSettings
} from './redux/actions';
import UserSettingsComponent from './user-settings-component';

const mapStateToProps = (state: ApplicationState) => ({
  userSettings: state.navbar.userSettings,
  t: state.i18n.t
});

export default connect(mapStateToProps, {
  toggleUserSettings,
  onChangeDropdowns,
  fetchUserSettings,
  updateUserSettings
})(UserSettingsComponent);
